import { Box, Chip, Divider, IconButton, useTheme } from '@mui/material'
import React from 'react'
import "./style.css";
import CustomTypography from 'components/Fileds/CustomTypography';
import { Add, Remove } from '@mui/icons-material';
import emptyCart from "assests/shopping 1.svg"
import { formatCurrency } from 'utils/function';

const OrderItemsContainer = ({ orderItems, handleRemoveItem, handleAddItem, userData, showLabel = true }) => {
    const theme = useTheme();
    return (
        <>
            {orderItems?.length > 0 ? (
                orderItems?.map((item, index) => {
                    const baseTotal = item.price * item.quantity
                    const addonTotal = item?.addOns?.reduce((sum, addon) => sum + addon.price * item.quantity, 0)
                    const totalWithAddons = baseTotal + addonTotal
                    const showUnitPrice = item.isMisc ? item.priceEntered : true
                    return (
                        <>
                            <Box key={`${item.id}-${index}`} sx={{ mb: 0, minHeight: "55px", pt: '5px', pb: '5px' }}>
                                <Box className='d-flex justify-content-between' sx={{ mb: 0 }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 0.75,
                                            width: '100px',
                                            minWidth: 0,
                                            flexWrap: 'wrap',
                                        }}
                                    >
                                        <CustomTypography
                                            label={item.name}
                                            variant={"body1"}
                                            sx={{ fontWeight: '500', mb: 0, wordBreak: 'break-word', fontSize: '16px', color: theme.palette.drawermenuitem.main }}
                                        />
                                        {item.isMisc && (
                                            <Chip
                                                label="MISC"
                                                size="small"
                                                sx={{
                                                    height: '18px',
                                                    borderRadius: '4px',
                                                    backgroundColor: '#000',
                                                    color: '#fff',
                                                    fontWeight: 700,
                                                    fontSize: '10px',
                                                    letterSpacing: '0.4px',
                                                    '& .MuiChip-label': {
                                                        px: "6px !important",
                                                        py: 0,
                                                        lineHeight: 1.2,
                                                    },
                                                }}
                                            />
                                        )}
                                    </Box>
                                    <Box className='d-flex align-items-center justify-cotent-center'>
                                        <IconButton
                                            size="small"
                                            sx={{
                                                border: `1px solid ${theme.palette.primary.main}`,
                                                borderRadius: "50%",
                                                width: "18px",
                                                height: "18px",
                                                p: 0.5,
                                            }}
                                            onClick={() => handleRemoveItem(item)}
                                        >
                                            <Remove fontSize="5px" sx={{ color: theme.palette.primary.main }} />
                                        </IconButton>
                                        <CustomTypography
                                            sx={{ mx: 1, mb: 0 }}
                                            label={item.quantity}
                                        />
                                        <IconButton
                                            size="small"
                                            sx={{
                                                border: `1px solid ${theme.palette.primary.main}`,
                                                borderRadius: "50%",
                                                width: "18px",
                                                height: "18px",
                                                p: 0.5,
                                            }}
                                            onClick={() => handleAddItem(item)}
                                        >
                                            <Add fontSize="5px" sx={{ color: theme.palette.primary.main }} />
                                        </IconButton>
                                    </Box>
                                    <CustomTypography
                                        variant="body1"
                                        label={`
                                        ${formatCurrency(item?.hasAddOns ? totalWithAddons : baseTotal, userData?.vendor?.currency)}`}
                                        sx={{ display: "flex", alignItems: "center", mb: 0, justifyContent: "center", color: theme.palette.drawermenuitem.main, fontSize: '15px', fontWeight: 400, width: "70px" }}
                                    />
                                </Box>
                                {/* {showUnitPrice && ( */}
                                <CustomTypography
                                    variant={"body2"}
                                    label={formatCurrency(item?.price?.toFixed(2) || 0, userData.vendor.currency)}
                                    sx={{ color: theme.palette.drawermenuitem.main }}
                                />
                                {/* )} */}

                                {/* Size information if available */}
                                {/* {item.size && (
                                <CustomTypography
                                    variant="body2"
                                    label={`Size: ${item?.size?.charAt(0).toUpperCase() + item.size.slice(1)}`}
                                    sx={{color:theme.palette.drawermenuitem.main}}
                                />
                            )} */}

                                {/* Add-ons section */}
                                {item?.addOns && item?.addOns?.length > 0 && (
                                    <Box sx={{ pt: 0.5 }}>
                                        <CustomTypography
                                            label={"Add-Ons"}
                                            sx={{
                                                fontWeight: 400,
                                                fontSize: "14px",
                                                textDecoration: "underline",
                                                color: theme.palette.drawermenuitem.main
                                            }}
                                        />
                                        {item?.addOns?.map((addon, idx) => (
                                            <CustomTypography
                                                key={idx}
                                                variant={"body2"}
                                                label={`
                                                • ${addon.name} - ${formatCurrency(addon.price.toFixed(2) || 0, userData?.vendor?.currency)}`
                                                }
                                                sx={{
                                                    ml: 1,
                                                    mb: 0,
                                                    color: theme.palette.drawermenuitem.main,
                                                    fontSize: "14px",
                                                }}
                                            />
                                        ))}
                                    </Box>
                                )}

                                {/* Notes section */}
                                {item.notes && (
                                    <Box sx={{ mt: 0.5 }}>
                                        <CustomTypography
                                            label={`Notes: ${item.notes}`}
                                            variant="body2"
                                            sx={{ fontStyle: "italic", fontSize: '14px', color: theme.palette.drawermenuitem.main, fontWeight: 300, mb: 0 }}
                                        //     fontStyle: item.isMisc ? 'normal' : 'italic',
                                        />
                                    </Box>
                                )}
                            </Box>
                            <Box key={index}>
                                <Divider sx={{ mt: "0px" }} />
                            </Box>
                        </>
                    )
                })
            ) : (
                <Box className='empty-menu-item-container'>
                    <Box className='empty-menu-item'
                        component="img"
                        src={emptyCart}
                        alt="Empty cart"
                    />
                    {showLabel && <CustomTypography
                        variant={"body1"}
                        label={"No items added to the cart yet."}
                        sx={{ color: theme.palette.lightgrey.main, fontSize: '14px', fontWeight: '300', }}
                    />}
                    <CustomTypography
                        variant={"body2"}
                        label={"Click “Add” button on the food item"}
                        sx={{ color: theme.palette.lightgrey.main }}
                    />

                </Box>
            )}
        </>
    )
}

export default OrderItemsContainer
